import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [user, setUser] = useState(null);
  const [resetToken, setResetToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const reset = params.get("reset");
    if (reset) {
      setResetToken(reset);
      setUser(false);
      return;
    }
    // Fallback Bearer : certains navigateurs (Safari/iOS) bloquent les cookies
    const stored = localStorage.getItem("d2r_token");
    if (stored) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
    }
    if (token) {
      axios.post(`${API}/auth/magic`, { token }, { withCredentials: true })
        .then((r) => {
          if (r.data.token) {
            localStorage.setItem("d2r_token", r.data.token);
            axios.defaults.headers.common["Authorization"] = `Bearer ${r.data.token}`;
          }
          setUser(r.data);
          toast.success("Connexion directe réussie", { description: "Pensez à générer un nouveau lien dans l'onglet Accès." });
        })
        .catch((err) => {
          setUser(false);
          toast.error("Lien invalide ou expiré", { description: err.response?.data?.detail || "Demandez un nouveau lien." });
        })
        .finally(() => window.history.replaceState({}, "", "/admin"));
      return;
    }
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("d2r_token");
        delete axios.defaults.headers.common["Authorization"];
        setUser(false);
      });
  }, []);

  const logout = () => {
    localStorage.removeItem("d2r_token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(false);
  };

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center">
        <p className="text-[#71717A] text-xs uppercase tracking-[0.3em]">Chargement…</p>
      </div>
    );
  }
  if (user === false) return <AdminLogin onLogin={setUser} resetToken={resetToken} />;
  return <AdminDashboard user={user} onLogout={logout} />;
}
